/**
 * Este archivo contiene los tipos de acciones que se pueden realizar en la aplicación.
 * Sirve para mantener un control de las acciones que se pueden realizar en la aplicación.
 *
 * @summary Tipos de acciones
 */

export const types = {
  cargarMarks: "[Chat] Cargar etiquetas",
  loadAgentes: "[Chat] Cargar agentes",
  nuevosMensajesBot: "[Chat] Nuevos Mensajes del bot",
  totalAgentMessages: "[Chat] Total de mensajes de agentes",
  unreadMessages: "[Chat] Total de mensajes no leidos",
  chatOnHold: "[Chat] Total de chats en espera",
  estDash: "[Chat] Datos de Gupshup",
  nuevasEstadisticas: "[Chat] Nuevas estadisticas de agentes",
  loadRoles: "[SYS] Cargar roles",

  // ************** CHAT ********************
  loadChats: "[Chat] Cargar Lista de chats",
  loadMoreChats: "[Chat] Cargar mas chats",
  clearChatList: "[Chat] Limpiar Lista de chats",
  selectChat: "[Chat] Seleccionar Chat",
  loadMessages: "[Chat] Cargar Mensajes",
  loadMoreMessages: "[Chat] Cargar mas mensajes",
  reloadMessages: "[Chat] Recargar Mensajes",
  newMessage: "[Chat] Nuevo Mensaje",
  newMessageOnChat: "[Chat] Nuevo Mensaje en Chat Activo",
  updateMessage: "[Chat] Actualizar Mensaje",
  newChat: "[Chat] Nuevo Chat",
  closeChat: "[Chat] Cerrar Chat",
  tagChange: "[Chat] Cambiar Etiqueta",
  refreshChatList: "[Chat] Refrescar Lista de Chats",
  clearMessages: "[Chat] Limpiar Mensajes",

  // **************RESPUESTAS RAPIDAS********************

  answers: "[Chat] cargar respuestas rapidas",

  nuevoMensaje: "[Chat] Nuevo Mensaje",
  newSms: "[Chat] Total de nuevos Mensajes",

  lastMensaje: "[Chat] ultimo mensaje de usuario Mensaje",
  cerrarSesion: "[Chat] Cerrar Sesion ",

  // **************CONFIGURACION********************
  changeColorMode: "[Chat] Cambiar Modo de Color",
  loadConfig: "[Chat] Cargar Configuracion",

  // **************USUARIOS CATEGORIAS********************
  loadChatsCat: "[Chat] Cargar Lista de chats Categorias",
  moveChatToCategory: "[Chat] Move chat to another category",
  removeChatUser: "[Chat]Quitar usuario de categorias",
  selectChatTab: "[Chat] Seleccionar Chat TABS",

};
